import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { getSuccessSections } from "api/Finances";

export const useMonthlySuccess = (filter_date: { year: number, month: number }) => {

    const { data, isLoading } = useQuery<Array<any>>(
        ['monthlySuccess', filter_date],
        () => {
            return getSuccessSections({
                filter_date: filter_date.year + '-' + filter_date.month
            });
        }, {
        onError() {
            toast.error(`Something went wrong. Please try again later.`);
        },
    }
    );

    return {
        data,
        isLoading,
    };
};
